function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap';
import ReportFormFilter from '../reports/reportFormFilter';
import FormFormFilter from './formFormFilter';
import entityComposition from '../common/classes/entityComposition';
import SearchInput from '../common/search/searchInput';
import Icon from '../common/containers/icon';
const FormsFilterPanel = ({
  children: _children = [],
  onFilter: _onFilter = () => {},
  onFilterClear: _onFilterClear = null,
  filters: _filters = {},
  formTypeIdentifier: _formTypeIdentifier = null,
  formActions: {
    serverIndex
  },
  formType: {
    list: formTypeList = []
  },
  form,
  form: {
    indexQuery
  },
  settings: {
    settings: {
      cabinets: _cabinets = {}
    } = {}
  }
}) => {
  const formFilterComponents = [];
  const formFormFilters = useMemo(() => {
    let result = [];
    if (_cabinets !== undefined && _cabinets[_formTypeIdentifier] !== undefined && _cabinets[_formTypeIdentifier].filters !== undefined) {
      result = _cabinets[_formTypeIdentifier].filters;
    }
    return result;
  }, [_cabinets, _formTypeIdentifier]);
  const [currentSearchString, setCurrentSearchString] = useState(null);
  useEffect(() => {
    let rightFormTypeID;
    let formFilter;
    formFormFilters.forEach(filter => {
      if (filter.display !== false) {
        rightFormTypeID = filter.formTypeIdentifier;
        formFilter = filter;
      }
    });
    const indexFilters = _objectSpread({}, indexQuery.filters);
    const getSearchText = (filter, searchText) => {
      if (!searchText) {
        return null;
      }
      if (filter.index) {
        return [{
          index: formFilter.index,
          value: currentSearchString
        }];
      }
      return searchText;
    };
    if (currentSearchString) {
      indexFilters.text = getSearchText(formFilter, currentSearchString);
    }
    return formTypeList[0] && rightFormTypeID && serverIndex([rightFormTypeID], _objectSpread(_objectSpread({}, indexQuery), {}, {
      filters: indexFilters
    }));
  }, [formFormFilters, formTypeList, indexQuery, serverIndex, currentSearchString]);
  formFormFilters.forEach(filter => {
    if (filter.display !== false && filter.filterType === 'FormFormFilter') {
      const currentFilter = [];
      form.list.forEach(formItem => {
        const {
          id,
          title: name
        } = formItem;
        currentFilter.push({
          id,
          name
        });
      });
      formFilterComponents.push(/*#__PURE__*/React.createElement(FormFormFilter, {
        key: filter.title,
        label: filter.title,
        selectedForms: _filters.formForm || [],
        forms: currentFilter,
        formTypeIdentifier: filter.formTypeIdentifier,
        onFilter: _onFilter,
        onSearch: text => setCurrentSearchString(text)
      }));
    } else if (filter.display !== false && filter.filterType === 'ReportFormFilter') {
      formFilterComponents.push(/*#__PURE__*/React.createElement(ReportFormFilter, {
        key: filter.formTypeIdentifier,
        label: filter.formTypeIdentifier,
        onBack: () => {},
        formType: formTypeList[0]
      }));
    }
  });
  const filterTextClear = () => _onFilter('text', '');
  const clearAll = () => {
    if (_onFilterClear) {
      _onFilterClear();
    } else {
      filterTextClear();
    }
  };
  const filterText = text => _onFilter('text', text);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-ifp-title"
  }, "Filter")), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: clearAll,
    className: "float-md-right t-if-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
    className: "t-if-search",
    type: "text",
    text: _filters.text,
    onChange: value => filterText(value),
    onClear: filterTextClear
  }), _children, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '10px'
    }
  }, formFilterComponents)));
};
FormsFilterPanel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  formTypeIdentifier: PropTypes.string,
  form: PropTypes.shape({
    loading: PropTypes.bool,
    list: PropTypes.arrayOf(PropTypes.shape({
      length: PropTypes.number,
      typeName: PropTypes.string
    })),
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    selected: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  formForm: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  formActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    serverFilter: PropTypes.func,
    create: PropTypes.func,
    select: PropTypes.func
  }).isRequired,
  filters: PropTypes.shape({
    text: PropTypes.string,
    formForm: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.shape({}))])
  }),
  formType: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  formTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  formFormActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  filterChange: PropTypes.shape({
    serverIndex: PropTypes.func
  }),
  onFilter: PropTypes.func,
  onFilterClear: PropTypes.func,
  settings: PropTypes.shape({
    settings: PropTypes.shape({})
  }).isRequired
};
export { FormsFilterPanel as TestFormsFilterPanel };
export default entityComposition(FormsFilterPanel, ['settings', 'formType', 'job', 'organization', 'formForm', 'form'], {
  formIndexQuery: state => state.form.indexQuery
}, ['form']);